//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
//#endregion

/**
 * 안전보건교육 - 연간교육 계획표 (SAT_BASIC_01) 전용 로직
 * other 케이스에서 사용
 */

// 안전보건교육 - 연간교육 계획표 인쇄 함수
export const PrintLogic1 = async (
  documentData, // 선택된 항목 데이터 (사용하지 않지만 시그니처 통일을 위해 유지)
  dispatch,
  setLoading,
  rowData1, // 전체 리스트
  searchRef
) => {
  setLoading(true);

  let headerData = [];
  let tableData = [];

  try {
    headerData.push({
      safetyYear: dayjs(searchRef?.current?.searchYear).format('YYYY'),
    });

    tableData = rowData1;

    const printData = {
      FileName: 'TRA_BASIC_03',
      TableData: JSON.stringify(tableData),
      HeaderData: JSON.stringify(headerData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    // response.data가 blob인 경우 그대로 반환
    if (response.data instanceof Blob) {
      return response.data;
    }
    // response.data가 다른 형태인 경우 blob으로 변환
    else if (response.data) {
      return new Blob([response.data], { type: 'application/pdf' });
    } else {
      console.error('PrintLogic1: 응답 데이터가 없습니다.');
      return null;
    }
  } catch (e) {
    console.log(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
  } finally {
    setLoading(false);
  }
};
